import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-first-step-carriers',
	templateUrl: './first-step.component.html',
	styleUrls: ['./first-step.component.css'],
})
export class FirstStepComponent implements OnInit {
	public fileToUpload: File = null;
	public fileData: string[] = [];

	@ViewChild('fileInput') fileInput: ElementRef;
	@Output() fileUploadedEvent: EventEmitter<object> = new EventEmitter();
	@Output() clearFileEvent: EventEmitter<null> = new EventEmitter();

	constructor(private utilService: UtilService) {}

	ngOnInit() {}

	handleFileInput(files: FileList) {
		const self = this;
		this.fileToUpload = files.item(0);
		var fileReader = new FileReader();
		fileReader.onload = (fileLoadedEvent: any) => {
			let textFromFileLoaded = fileLoadedEvent.target.result;
			let allLines = this.removeBlankLines(textFromFileLoaded.split(/\r\n|\n/));
			let headers = allLines[0].split(',');
			var lines = [];
			for (var i = 0; i < allLines.length; i++) {
				var data = allLines[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
				if (data.length == headers.length) {
					var tarr = [];
					for (var j = 0; j < headers.length; j++) {
						tarr.push(data[j]);
					}
					lines.push(tarr);
				}
			}
			self.fileData = lines;
			self.fileUploadedEvent.emit({
				fileToUpload: self.fileToUpload,
				fileData: self.fileData,
			});
		};
		fileReader.readAsText(this.fileToUpload, 'UTF-8');
	}

	removeBlankLines(allLines: string[]) {
		let nonBlankLines = [];
		for (let i = 0; i < allLines.length; i++) {
			const line = allLines[i];
			let rowElements = line.split(',');
			if (rowElements.length == 1) {
				continue;
			}
			nonBlankLines.push(line);
		}
		return nonBlankLines;
	}

	clearFile() {
		if (!this.utilService.isNullOrUndefined(this.fileInput)) {
			this.fileInput.nativeElement.value = '';
		}
		this.fileToUpload = null;
		this.fileData = null;
		this.clearFileEvent.emit();
	}
}
